import React, { useEffect } from 'react';
import './styles/main.css';
import Profile from './components/Account/Profile';
import visitProfile from './components/Account/visitProfile'
import CodeEditor from './components/CodeEditor/CodeEditor';
import CodeEditorAPI from './components/CodeEditorAPI/CodeEditor';

import Pens from './components/Pens/Pens';
import SignUp from './components/SignUp/SignUp';
import Login from './components/Login/Login';
import Comments from './components/Comments/Comments';
import Search from './components/Search/Search';
import Account from './components/Account/account';
import Challenges from './components/Challenges/Challenges'
import { Switch, Route } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import Showcase from './components/Account/Showcase';
import Homepage from './components/Homepage'
import { useDispatch } from 'react-redux'
import { loginSuccess, logoutUser, setUserData } from "./redux/actions/authActions"
import firebase from 'firebase'
const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    firebase.auth().onAuthStateChanged(user => {
        if(user)
          {
            dispatch(loginSuccess({
              uid : user.uid
            }))
            firebase.firestore().collection("users").doc(user.uid).get()
            .then(snap => {
              dispatch(setUserData({
                ...snap.data(),
                uid : user.uid,
                photo_url : user.photoURL
              }))
            })
          }
        else
            dispatch(logoutUser())
    })
},[])

function inIframe () {
  try {
      return window.self !== window.top;
  } catch (e) {
      return true;
  }
}
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={Homepage} />
          <Route exact path="/editor/:id" component={CodeEditor} />
          <Route path="/editor" component={CodeEditor} />
          <Route path="/pens" component={Pens} />
          <Route path="/profile/:id" component={visitProfile} />
          <Route path="/profile" component={Profile} />
          <Route path="/account" component={Account} />
          <Route path="/signup" component={SignUp} />
          <Route path="/login" component={Login} />
          <Route exact path="/api/editor" component={CodeEditorAPI} />
          <Route exact path="/api/editor/:access_id" component={CodeEditorAPI} />
          <Route path="/comments/:id" component={Comments} />
          <Route path="/search" component={Search} />
          <Route path="/showcase" component={Showcase} />
          <Route path="/challenges" component={Challenges} />
        </Switch>
        { !inIframe() && <Footer />}
      </div>
    );
  }


export default App;


// WEBPACK FOOTER //
// ./src/App.js